import { createIcon } from "@chakra-ui/react";

const ArchiveIcon = createIcon({
  displayName: "ArchiveIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        d="M15 13.5H9V12H15V13.5Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.1025 3.00488C20.6067 3.05621 21 3.48232 21 4V20L20.9951 20.1025C20.9472 20.573 20.573 20.9472 20.1025 20.9951L20 21H4L3.89746 20.9951C3.42703 20.9472 3.05278 20.573 3.00488 20.1025L3 20V4C3 3.48232 3.39333 3.05621 3.89746 3.00488L4 3H20L20.1025 3.00488ZM4.5 19.5H19.5V9.75H4.5V19.5ZM4.5 8.25H19.5V4.5H4.5V8.25Z"
        fill="currentColor"
      />
    </>
  ),
});

export default ArchiveIcon;
